import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MaterialModule } from '@app/shared/material.module';

@Component({
	selector: 'app-overlay-blocker',
	templateUrl: './overlay-blocker.component.html',
	styleUrls: ['./overlay-blocker.component.less'],
	standalone: true,
	imports: [NgIf, MaterialModule],
})
export class OverlayBlockerComponent {
	@Input() isVisible = false;
	@Input() buttonText = 'Refresh';
	@Input() buttonColor: 'primary' | 'accent' | 'warn' = 'primary';

	@Output() buttonClick = new EventEmitter<void>();

	onButtonClick(): void {
		this.buttonClick.emit();
	}
}
